export default () => {
    if(typeof window.scroll === 'function'){
        let heightHeader = document.querySelector('.header-home').clientHeight;
        window.scroll({
            behavior: 'smooth',
            left: 0,
            top: heightHeader
        });
    }
}